import { Auctions } from '@sorare/marketplace/src/components/market/Auctions';

import { SelectedLeaderboardBanner } from '#src/components/searchCards/SelectedLeaderboardBanner/index.tsx';

const AuctionsPage = () => {
  return <Auctions banner={<SelectedLeaderboardBanner />} />;
};

export default AuctionsPage;
